import { storeRegistry } from "../lib/store/storeRegistry";
const ApplicationpPrefix = "ApoteaPackingApplication-";

class Persistor {
    _store() {
        const store = storeRegistry.getStore();

        return { ...store.cartReducer, ...store.loginInfoReducer, ...store.applicationStateReducer };
    }

    select(key) {
        const value = this._store()[key];

        if (value) {
            return value;
        }
    }

    _containsApplicationPrefix(toCheck, prefix = "") {
        return toCheck.indexOf(ApplicationpPrefix + prefix) > -1;
    }
    _getFullKey(key) {
        if (this._containsApplicationPrefix(key)) return key;
        return ApplicationpPrefix + key;
    }

    _getValueObjectFromSession(key) {
        var valueString = sessionStorage[this._getFullKey(key)];
        if (valueString) return JSON.parse(valueString);
    }
    _getValueFromSession(key) {
        var foundObject = this._getValueObjectFromSession(key);
        if (foundObject) return foundObject.value;
    }

    //all values are saved with prefixed key, in an object with "value, timestamp(epoch in ms)" pair
    _setValueToSession(key, value) {
        sessionStorage[this._getFullKey(key)] = JSON.stringify({
            value: value,
            timestamp: new Date().getTime(),
        });
    }
    //removes all variables saved to sessionState where key contains applicationPrefix should avoid removing other keys.
    async _purgeState(prefix = "") {
        var toRemove = Object.keys(sessionStorage).filter((x) =>
            this._containsApplicationPrefix(x, prefix)
        );
        toRemove.forEach((key) => sessionStorage.removeItem(key));
        return toRemove.length;
    }
    _storageShouldBePurged(maxAgeSeconds, keyToCheck) {
        // var decidingObject = this._getValueObjectFromSession(keyToCheck);

        // if (!decidingObject) return true;

        const store = this._store();
        const age = store.latestDispatch;

        //var age = decidingObject.timestamp;
        const currentTimeStamp = new Date().getTime();
        const ageOffset = age + maxAgeSeconds * 1000;

        return ageOffset < currentTimeStamp && store.operatorID !== -1;
    }

    isStateInactive(maxAgeSeconds, keyToCheck, prefix) {
        return this._storageShouldBePurged(maxAgeSeconds, prefix + keyToCheck);
    }

    // baseObject: contains the object to be restored with default values.
    // maxAgeSeconds: how long can the session be inactive before purge of stored data.
    // decidingKey: the key to check the age of, as all keys have there own timestamp.
    restoreState(baseObject, maxAgeSeconds, decidingKey, prefix = "") {
        //prevent baseObject to be overwritten (retains default values)
        var baseObjectCopy = { ...baseObject };
        if (this._storageShouldBePurged(maxAgeSeconds, prefix + decidingKey)) this._purgeState(prefix);

        Object.keys(baseObjectCopy).forEach((key) => {
            var foundValue = this._getValueFromSession(prefix + key);
            if (foundValue || foundValue === 0 || foundValue === false) baseObjectCopy[key] = foundValue;
        });

        return baseObjectCopy;
    }
    insertState(objectToPersist, prefix = "") {
        ////console.log("writing to state");
        Object.keys(objectToPersist).forEach((key) => {
            this._setValueToSession(prefix + key, objectToPersist[key]);
        });
    }
    getValue(key) {
        return this._getValueFromSession(key);
    }
    async clearPersistedState(prefix = "") {
        await this._purgeState(prefix);
    }
}

export const StatePersistor = new Persistor();
